export default __webpack_public_path__ + "static/media/angry.3e378785.png";